import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

export const RESPONSIBLE = 'responsible';
export const SUPERVISOR = 'supervisor';

class TaskRoleAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Task-Role';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'task-roles';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
            'created_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'isSystem',
            'name',
            'slug',
            'description',
            'organizationUuid',
            'workspaceUuid',
            'ownerWorkspaceOrganizationMemberUuid',
            'workspaceOrganizationMemberUuid',
            'organization',
            'workspace',
            'ownerWorkspaceOrganizationMember',
            'assignees',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return [];
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            isSystem: {
                type: 'string',
                presence: true,
            },
            taskRoleName: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            taskRoleSlug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            organizationUuid: {
                type: 'string',
                presence: true,
            },
            workspaceUuid: {
                type: 'string',
                presence: true,
            },
            ownerWorkspaceOrganizationMemberUuid: {
                type: 'string',
                presence: true,
            },
        };
    }

}

export default TaskRoleAppResource;
